export default __webpack_public_path__ + "static/media/verdighet.4c3a8e3d.jpg";